import * as React from 'react'

/**
 * @returns the text inside the `<title>` html element.
 */
export const usePageTitle = () => {
    const [title, setTitle] = React.useState('')
    React.useEffect(() => {
        // Set the current page title
        setTitle(document.title)

        // Create a html observer, that updates the state every time something inside `head` changes.
        const observer = new MutationObserver(() => setTitle(document.title))
        observer.observe(document.head, {
            subtree: true,
            characterData: true,
            childList: true,
        })

        return () => observer.disconnect()
    }, [])

    return title
}
